import React from 'react';
import NoticeStore from '@/stores/notice';
import SkuStore from '@/stores/sku';
import PageStore from '@/stores/page';
import doLog from '@/common/log';
import NumberPicker from '@/common/number-picker';
interface PropTypes {
  max: number;
  min: number;
  type: SkuTypes.TypeInfo;
  rule: PriceTypes.Root;
  skuKey: string;
  quantity: number;
  i18n: DetailTypes.i18n;
  moq: number;
  limitCount: number;
}

export default function Index(props: PropTypes) {
  const { max, min = 0, moq, rule, type, skuKey, quantity, i18n, limitCount } = props;
  const noticeStore = NoticeStore((state) => state);
  const secondScreen = PageStore((state) => state.secondScreen);
  const skuStore = SkuStore((state) => state);
  const { isSoldOut } = skuStore.product;
  const skuInfo = skuStore[type];
  const skuSelectInfo = skuInfo.mapInfo[skuInfo.selectedKey];
  const { batchNum, unit, unitEven } = rule;
  // 是否走营销活动限购逻辑
  const isLimitCount = limitCount && type === 'product' && skuInfo.quantity >= limitCount;

  return (
    <NumberPicker
      min={min}
      max={max}
      value={quantity}
      step={type === 'product' ? batchNum : 1}
      onBlur={(number) => {
        if (number > max) {
          noticeStore.modify(
            i18n['detail_pc_sku_panel_sku_reach_limit_tips']?.replace(
              '{0}',
              skuSelectInfo.maxQuantity ? skuSelectInfo.maxQuantity : max,
            ),
          );
        }
      }}
      onChange={(number) => {
        doLog('/sc.details.skuQuantityChange', `second=${secondScreen}`);
        if (isSoldOut) return noticeStore.modify(i18n['detail_sku_soldout_tips']); // 手动输入触发
        // 设置数量
        skuStore.setSkuNumber(type, skuKey, number);
        // 设置价格
        skuStore.setTotalPrice({
          type,
          rule,
          moq,
        });

        // 当商品无库存出提示
        if (number >= max)
          return noticeStore.modify(
            i18n['detail_sku_availablestock_tips'].replace(
              '{0}',
              max + ' ' + (max > 1 ? unitEven : unit),
            ),
          );
      }}
      //到达最大值，加号置灰，再次点击加号触发onMaxQuantity事件
      onMaxQuantity={() => {
        if (isSoldOut) return noticeStore.modify(i18n['detail_sku_soldout_tips']); // 手动输入触发
        // 当商品限购时出限购提示
        if (isLimitCount)
          return noticeStore.modify(
            i18n['sku_purchase_limit_tips'].replace(
              '{0}',
              limitCount + ' ' + (limitCount > 1 ? unitEven : unit),
            ),
          );
        noticeStore.modify(
          i18n['detail_sku_availablestock_tips'].replace(
            '{0}',
            max + ' ' + (max > 1 ? unitEven : unit),
          ),
        );
      }}
    />
  );
}
